/**
 * `html.is-scrolling` — present while the page is being scrolled, gone SCROLLING_REST_MS after the last scroll event.
 *
 * It exists so CSS can rest things that loop forever (the Stylon character's float and glow) for the length of a
 * scroll: they repaint on every frame, and a scroll wants every frame it can get. One passive listener; the class is
 * written on the first event and removed by one timer, not per event.
 */
export const SCROLLING_REST_MS = 150;

export function bindScrollingFlag(win = window) {
  const root = win.document.documentElement;
  let timer = 0;
  let on = false;
  const rest = () => { on = false; timer = 0; root.classList.remove('is-scrolling'); };
  const onScroll = () => {
    if (!on) { on = true; root.classList.add('is-scrolling'); }
    if (timer) win.clearTimeout(timer);
    timer = win.setTimeout(rest, SCROLLING_REST_MS);
  };
  win.addEventListener('scroll', onScroll, { passive: true });
  return () => {
    win.removeEventListener('scroll', onScroll);
    if (timer) win.clearTimeout(timer);
    root.classList.remove('is-scrolling');
  };
}
